<p [ngClass]="{ flip: alignIcon === 'right' }">
	<cdx-svg-icon name="onecard-active"></cdx-svg-icon><span>Powered by Onecard</span>
</p>
